import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsWorkflowsRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-workflows',
	path: '/plugins/servlet/project-config/:projectKey/workflows',
};
